// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminRecapWrap {
  max-width: 1100px;
}

/* Header */
.recapHeader {
  padding-bottom: 8px;
}

.recapHeaderTop {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
}

.recapMeta {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

.recapMetaItem {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.05);
  font-weight: 800;
  font-size: 12px;
}

.recapSubtitle {
  margin-top: 8px;
  margin-bottom: 0;
  opacity: 0.9;
}

/* Cards */
.recapCard {
  border-radius: 22px;
  background: #fff;
  padding: 18px 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(17, 24, 39, 0.06);
}

.recapCardTitle {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 900;
  margin-bottom: 14px;
  font-size: 14px;
  opacity: 0.95;
}

.recapTextarea {
  resize: none;
}

/* Badges */
.recapBadge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 999px;
  font-weight: 900;
  font-size: 12px;
  border: 1px solid transparent;
}

.recapBadgeDanger {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.22);
}

.recapBadgeWarning {
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.26);
}

.recapBadgeNeutral {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.22);
}

/* Article preview */
.recapArticlePreview {
  display: flex;
  gap: 14px;
  align-items: stretch;
  margin-top: 8px;
}

.recapArticleThumb {
  width: 150px;
  min-width: 150px;
  height: 120px;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(17, 24, 39, 0.08);
  background: rgba(17, 24, 39, 0.03);
}

.recapArticleThumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.recapArticleInfo {
  flex: 1 1;
  min-width: 0;
}

.recapArticleTitleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.recapArticleTitle {
  font-weight: 900;
  font-size: 16px;
  line-height: 1.2;
  margin: 0;
}

.recapPill {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 7px 12px;
  border-radius: 999px;
  font-weight: 900;
  font-size: 12px;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.22);
}

.recapArticleDesc {
  margin-top: 8px;
  font-size: 13px;
  opacity: 0.92;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.recapArticleMeta {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.recapMetaChip {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(17, 24, 39, 0.05);
  border: 1px solid rgba(17, 24, 39, 0.08);
  font-weight: 800;
  font-size: 12px;
}

/* Actions */
.recapActions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.recapBtnLight {
  border-radius: 999px;
  padding: 10px 16px;
  font-weight: 900;
  border: 1px solid rgba(17, 24, 39, 0.12);
  background: #fff;
}

.recapBtnLight:hover {
  background: rgba(17, 24, 39, 0.04);
}

/* Loading */
.recapLoading {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 18px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(17, 24, 39, 0.06);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);
}

/* ✅ Preuve */
.recapEmptyProof {
  padding: 12px 14px;
  border-radius: 16px;
  background: rgba(17, 24, 39, 0.04);
  border: 1px dashed rgba(17, 24, 39, 0.14);
  font-weight: 700;
  font-size: 13px;
  opacity: 0.9;
}

.recapProofWrap {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.recapProofThumb {
  position: relative;
  width: 210px;
  height: 150px;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(17, 24, 39, 0.08);
  background: rgba(17, 24, 39, 0.03);
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.06);
}

.recapProofThumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.recapProofHover {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 900;
  font-size: 13px;
  color: #111827;
  background: rgba(255, 255, 255, 0.65);
  opacity: 0;
  transition: 0.2s ease;
}

.recapProofThumb:hover .recapProofHover {
  opacity: 1;
}

/* Overlay preview */
.image-preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 9999;
}

.image-preview-overlay img {
  max-width: 92vw;
  max-height: 92vh;
  border-radius: 18px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

/* ===== Slider image article ===== */
.recapArticleThumbSlider {
  position: relative;
}

.recapArticleThumbSlider img {
  cursor: pointer;
}

.recapNavBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  font-weight: 900;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(17, 24, 39, 0.12);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.10);
  transition: 0.2s ease;
  z-index: 2;
}

.recapNavBtn:hover {
  background: rgba(255, 255, 255, 0.92);
  transform: translateY(-50%) scale(1.05);
}

.recapNavBtn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  transform: translateY(-50%);
}

.recapNavLeft {
  left: 8px;
}
.recapNavRight {
  right: 8px;
}

.recapImgCounter {
  position: absolute;
  bottom: 8px;
  right: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 900;
  background: rgba(17, 24, 39, 0.55);
  color: #fff;
  z-index: 2;
}

/* Mini thumbs */
.recapMiniThumbs {
  margin-top: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.recapMiniThumb {
  width: 44px;
  height: 36px;
  border-radius: 10px;
  object-fit: cover;
  border: 1px solid rgba(17, 24, 39, 0.10);
  cursor: pointer;
  opacity: 0.7;
  transition: 0.2s ease;
}

.recapMiniThumb:hover {
  opacity: 1;
  transform: translateY(-1px);
}

.recapMiniThumb.active {
  opacity: 1;
  border: 2px solid rgba(59, 130, 246, 0.7);
}

/* Ligne titre + badge total */
.recapCardTitleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

/* Pills "X signalement(s)" */
.recapCountPill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 999px;
  font-weight: 900;
  font-size: 12px;
  border: 1px solid rgba(17, 24, 39, 0.10);
  background: rgba(17, 24, 39, 0.04);
}

.recapCountPillArticle {
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.26);
}

.recapCountPillUser {
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.22);
}

/* Actions admin */
.recapAdminActions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.recapDangerBtn,
.recapDangerOutlineBtn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  padding: 10px 14px;
  font-weight: 900;
  border: 1px solid rgba(17, 24, 39, 0.10);
}

.recapDangerBtn {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.26);
}

.recapDangerBtn:hover {
  background: rgba(239, 68, 68, 0.18);
}

.recapDangerOutlineBtn {
  background: #fff;
  border-color: rgba(239, 68, 68, 0.26);
}

.recapDangerOutlineBtn:hover {
  background: rgba(239, 68, 68, 0.06);
}

.recapDangerBtn:disabled,
.recapDangerOutlineBtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.recapDangerBtn .spinner-border,
.recapDangerOutlineBtn .spinner-border {
  width: 16px;
  height: 16px;
}

.recapAdminHint {
  margin-top: 10px;
  font-size: 12px;
  opacity: 0.9;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(17, 24, 39, 0.04);
  border: 1px dashed rgba(17, 24, 39, 0.14);
}

.recapSuccessBtn{
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  padding: 10px 14px;
  font-weight: 900;
  background: rgba(34, 197, 94, 0.12);
  border: 1px solid rgba(34, 197, 94, 0.22);
}

.recapSuccessBtn:hover {
  background: rgba(34, 197, 94, 0.18);
}

.recapOutlineSuccessBtn{
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border-radius: 999px;
  padding: 10px 14px;
  font-weight: 900;
  background: #fff;
  border-color: rgba(34, 197, 94, 0.22);
}

.recapOutlineSuccessBtn:hover {
  background: rgba(34, 197, 94, 0.06);
}

.recapSuccessBtn:disabled {
  background-color: #c0c0c0;
  border-color: #a0a0a0;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.7;
}

.recapOutlineSuccessBtn:disabled {
  background-color: #f5f5f5;
  border-color: #d0d0d0;
  color: #999999;
  cursor: not-allowed;
  opacity: 0.6;
}

.recapSuccessBtn:disabled:hover,
.recapOutlineSuccessBtn:disabled:hover {
  background-color: inherit;
  color: inherit;
}



/* Responsive */
@media (max-width: 576px) {
  .recapArticlePreview {
    flex-direction: column;
  }
  .recapArticleThumb {
    width: 100%;
    min-width: 100%;
    height: 180px;
  }

  .recapProofThumb {
    width: 100%;
    height: 190px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/signalement/AdminSignalementRecapPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;EAClC,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,wCAAwC;EACxC,2CAA2C;EAC3C,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,UAAU;AACZ;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;;;AAIA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".adminRecapWrap {\n  max-width: 1100px;\n}\n\n/* Header */\n.recapHeader {\n  padding-bottom: 8px;\n}\n\n.recapHeaderTop {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.recapMeta {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.recapMetaItem {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  padding: 7px 12px;\n  border-radius: 999px;\n  background: rgba(17, 24, 39, 0.05);\n  font-weight: 800;\n  font-size: 12px;\n}\n\n.recapSubtitle {\n  margin-top: 8px;\n  margin-bottom: 0;\n  opacity: 0.9;\n}\n\n/* Cards */\n.recapCard {\n  border-radius: 22px;\n  background: #fff;\n  padding: 18px 18px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);\n  border: 1px solid rgba(17, 24, 39, 0.06);\n}\n\n.recapCardTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 900;\n  margin-bottom: 14px;\n  font-size: 14px;\n  opacity: 0.95;\n}\n\n.recapTextarea {\n  resize: none;\n}\n\n/* Badges */\n.recapBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  font-weight: 900;\n  font-size: 12px;\n  border: 1px solid transparent;\n}\n\n.recapBadgeDanger {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(239, 68, 68, 0.22);\n}\n\n.recapBadgeWarning {\n  background: rgba(245, 158, 11, 0.14);\n  border-color: rgba(245, 158, 11, 0.26);\n}\n\n.recapBadgeNeutral {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.22);\n}\n\n/* Article preview */\n.recapArticlePreview {\n  display: flex;\n  gap: 14px;\n  align-items: stretch;\n  margin-top: 8px;\n}\n\n.recapArticleThumb {\n  width: 150px;\n  min-width: 150px;\n  height: 120px;\n  border-radius: 18px;\n  overflow: hidden;\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  background: rgba(17, 24, 39, 0.03);\n}\n\n.recapArticleThumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.recapArticleInfo {\n  flex: 1;\n  min-width: 0;\n}\n\n.recapArticleTitleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.recapArticleTitle {\n  font-weight: 900;\n  font-size: 16px;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.recapPill {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  padding: 7px 12px;\n  border-radius: 999px;\n  font-weight: 900;\n  font-size: 12px;\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.22);\n}\n\n.recapArticleDesc {\n  margin-top: 8px;\n  font-size: 13px;\n  opacity: 0.92;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.recapArticleMeta {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.recapMetaChip {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  padding: 7px 12px;\n  border-radius: 999px;\n  background: rgba(17, 24, 39, 0.05);\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  font-weight: 800;\n  font-size: 12px;\n}\n\n/* Actions */\n.recapActions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.recapBtnLight {\n  border-radius: 999px;\n  padding: 10px 16px;\n  font-weight: 900;\n  border: 1px solid rgba(17, 24, 39, 0.12);\n  background: #fff;\n}\n\n.recapBtnLight:hover {\n  background: rgba(17, 24, 39, 0.04);\n}\n\n/* Loading */\n.recapLoading {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 18px;\n  border-radius: 18px;\n  background: #fff;\n  border: 1px solid rgba(17, 24, 39, 0.06);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.06);\n}\n\n/* ✅ Preuve */\n.recapEmptyProof {\n  padding: 12px 14px;\n  border-radius: 16px;\n  background: rgba(17, 24, 39, 0.04);\n  border: 1px dashed rgba(17, 24, 39, 0.14);\n  font-weight: 700;\n  font-size: 13px;\n  opacity: 0.9;\n}\n\n.recapProofWrap {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.recapProofThumb {\n  position: relative;\n  width: 210px;\n  height: 150px;\n  border-radius: 18px;\n  overflow: hidden;\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  background: rgba(17, 24, 39, 0.03);\n  cursor: pointer;\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.06);\n}\n\n.recapProofThumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.recapProofHover {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-weight: 900;\n  font-size: 13px;\n  color: #111827;\n  background: rgba(255, 255, 255, 0.65);\n  opacity: 0;\n  transition: 0.2s ease;\n}\n\n.recapProofThumb:hover .recapProofHover {\n  opacity: 1;\n}\n\n/* Overlay preview */\n.image-preview-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 9999;\n}\n\n.image-preview-overlay img {\n  max-width: 92vw;\n  max-height: 92vh;\n  border-radius: 18px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n}\n\n/* ===== Slider image article ===== */\n.recapArticleThumbSlider {\n  position: relative;\n}\n\n.recapArticleThumbSlider img {\n  cursor: pointer;\n}\n\n.recapNavBtn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  width: 34px;\n  height: 34px;\n  border-radius: 999px;\n  font-weight: 900;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px solid rgba(17, 24, 39, 0.12);\n  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.10);\n  transition: 0.2s ease;\n  z-index: 2;\n}\n\n.recapNavBtn:hover {\n  background: rgba(255, 255, 255, 0.92);\n  transform: translateY(-50%) scale(1.05);\n}\n\n.recapNavBtn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  transform: translateY(-50%);\n}\n\n.recapNavLeft {\n  left: 8px;\n}\n.recapNavRight {\n  right: 8px;\n}\n\n.recapImgCounter {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 900;\n  background: rgba(17, 24, 39, 0.55);\n  color: #fff;\n  z-index: 2;\n}\n\n/* Mini thumbs */\n.recapMiniThumbs {\n  margin-top: 10px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.recapMiniThumb {\n  width: 44px;\n  height: 36px;\n  border-radius: 10px;\n  object-fit: cover;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.2s ease;\n}\n\n.recapMiniThumb:hover {\n  opacity: 1;\n  transform: translateY(-1px);\n}\n\n.recapMiniThumb.active {\n  opacity: 1;\n  border: 2px solid rgba(59, 130, 246, 0.7);\n}\n\n/* Ligne titre + badge total */\n.recapCardTitleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n\n/* Pills \"X signalement(s)\" */\n.recapCountPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  font-weight: 900;\n  font-size: 12px;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  background: rgba(17, 24, 39, 0.04);\n}\n\n.recapCountPillArticle {\n  background: rgba(245, 158, 11, 0.14);\n  border-color: rgba(245, 158, 11, 0.26);\n}\n\n.recapCountPillUser {\n  background: rgba(59, 130, 246, 0.12);\n  border-color: rgba(59, 130, 246, 0.22);\n}\n\n/* Actions admin */\n.recapAdminActions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.recapDangerBtn,\n.recapDangerOutlineBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 999px;\n  padding: 10px 14px;\n  font-weight: 900;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n}\n\n.recapDangerBtn {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(239, 68, 68, 0.26);\n}\n\n.recapDangerBtn:hover {\n  background: rgba(239, 68, 68, 0.18);\n}\n\n.recapDangerOutlineBtn {\n  background: #fff;\n  border-color: rgba(239, 68, 68, 0.26);\n}\n\n.recapDangerOutlineBtn:hover {\n  background: rgba(239, 68, 68, 0.06);\n}\n\n.recapDangerBtn:disabled,\n.recapDangerOutlineBtn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.recapDangerBtn .spinner-border,\n.recapDangerOutlineBtn .spinner-border {\n  width: 16px;\n  height: 16px;\n}\n\n.recapAdminHint {\n  margin-top: 10px;\n  font-size: 12px;\n  opacity: 0.9;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(17, 24, 39, 0.04);\n  border: 1px dashed rgba(17, 24, 39, 0.14);\n}\n\n.recapSuccessBtn{\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 999px;\n  padding: 10px 14px;\n  font-weight: 900;\n  background: rgba(34, 197, 94, 0.12);\n  border: 1px solid rgba(34, 197, 94, 0.22);\n}\n\n.recapSuccessBtn:hover {\n  background: rgba(34, 197, 94, 0.18);\n}\n\n.recapOutlineSuccessBtn{\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 999px;\n  padding: 10px 14px;\n  font-weight: 900;\n  background: #fff;\n  border-color: rgba(34, 197, 94, 0.22);\n}\n\n.recapOutlineSuccessBtn:hover {\n  background: rgba(34, 197, 94, 0.06);\n}\n\n.recapSuccessBtn:disabled {\n  background-color: #c0c0c0;\n  border-color: #a0a0a0;\n  color: #666666;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.recapOutlineSuccessBtn:disabled {\n  background-color: #f5f5f5;\n  border-color: #d0d0d0;\n  color: #999999;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.recapSuccessBtn:disabled:hover,\n.recapOutlineSuccessBtn:disabled:hover {\n  background-color: inherit;\n  color: inherit;\n}\n\n\n\n/* Responsive */\n@media (max-width: 576px) {\n  .recapArticlePreview {\n    flex-direction: column;\n  }\n  .recapArticleThumb {\n    width: 100%;\n    min-width: 100%;\n    height: 180px;\n  }\n\n  .recapProofThumb {\n    width: 100%;\n    height: 190px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
